import Swiper from "swiper/bundle";

/** Composante Carousel de Timtools */
export default class Carousel {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;

    // Options par défaut pour la librairie Swiper
    this.defaultOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        type: "bullets"
      },
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev")
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      },
      scrollbar: {
        el: this.element.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
    };

    this.spaceBetween = {
      spaceBetween: 24
    };

    this.applyNavigation();
    this.init();
  }

  applyNavigation() {
    this.defaultOptions.navigation = this.defaultOptions.navigation || {};

    const wrapper = this.element.closest('[data-carousel-wrapper]') || this.element;

    const customNext = wrapper.querySelector('.custom-next');
    const customPrev = wrapper.querySelector('.custom-prev');

    const customScrollbar = wrapper.querySelector('.custom-scrollbar');

    this.defaultOptions.navigation.nextEl = customNext || this.element.querySelector('.swiper-button-next');
    this.defaultOptions.navigation.prevEl = customPrev || this.element.querySelector('.swiper-button-prev');

    this.defaultOptions.scrollbar.el = customScrollbar || this.element.querySelector('.swiper-scrollbar');
  }

  /**
   * Méthode d'initialisation
   */
  init() {
    let options = this.defaultOptions;

    // Gestion des paramètres différents lorsqu'on veut avoir
    // 2 slides visibles sur grand écran et une seule sur petit écran
    switch (this.element.dataset.carousel) {
      case "review":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          // Hauteur fixe sur grand écran pour que l'image ne bouge pas,
          // hauteur automatique sur mobile pour éviter un grand vide
          autoHeight: !window.matchMedia("(min-width: 992px)").matches,
          ...{
            slidesPerView: 1,
          }
        };
        break;
      case "two":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              768: {
                slidesPerView: 2
              }
            }
          }
        };
        break;
      case "three":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1200: {
                slidesPerView: 3
              }
            }
          }
        };
        break;
      case "four":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 3
              },
              1200: {
                slidesPerView: 4
              }
            }
          }
        };
        break;
      case "five":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 3
              },
              992: {
                slidesPerView: 4
              },
              1200: {
                slidesPerView: 5
              }
            }
          }
        };
        break;
      case "six":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 3
              },
              992: {
                slidesPerView: 4
              },
              1100: {
                slidesPerView: 5
              },
              1300: {
                slidesPerView: 6
              }
            }
          }
        };
        break;
      case "marquee":
        options = {
          ...this.defaultOptions,
          spaceBetween: 30,
          loop: true,
          speed: 1000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          slidesPerView: "auto",
        };
        break;
      case "footer":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          ...{
            slidesPerView: 1,
            breakpoints: {
              544: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 3
              },
              992: {
                slidesPerView: 4
              },
              1400: {
                slidesPerView: 6
              },
              1600: {
                slidesPerView: 7
              },
              1800: {
                slidesPerView: 8
              }
            },
            autoplay: {
              delay: 3000
            }
          }
        };
        break;
    }

    // Instanciation d'un nouveau Swiper avec les options
    new Swiper(this.element, options);
  }
}
